import * as config from '../../config_module';
import { PARAMS } from '../../const';

const API_PREFIX = '/api/v3';

export const API_CLASSROOMS = `${config.BACKEND_URL}${API_PREFIX}/classrooms`;
export const API_CLASSROOMS_ASSIGNMENTS = `${API_CLASSROOMS}/${PARAMS.CLASSROOM}/tasks`;
export const V3_API_CLASSROOMS_ASSIGNMENTS_TASKS = `${API_CLASSROOMS_ASSIGNMENTS}/${PARAMS.TASK}`;
